import { render, staticRenderFns } from "./HomeCardsItem.vue?vue&type=template&id=477116d8&scoped=true"
import script from "./HomeCardsItem.vue?vue&type=script&lang=js"
export * from "./HomeCardsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477116d8",
  null
  
)

export default component.exports